import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-6" }
const _hoisted_2 = { class: "flex align-middle items-center" }
const _hoisted_3 = ["for"]

import { Field, ErrorMessage } from "vee-validate"
  import { ref } from "vue"

  interface Props {
    name: string
    modelValue: string | number
    id: string
    value: string
    label: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CapsuleTemplate',
  props: {
    name: null,
    modelValue: null,
    id: null,
    value: null,
    label: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as {
    name: string
    modelValue: string | number
    id: string
    value: string
    label: string
  }

  
  /**
   *
   * @param newValue   - any type
   * updates, and emits the value of the radio component
   */
  const setValue = (newValue: any) => {
    if (newValue === undefined) {
      return newValue
    }
    emit("update:modelValue", newValue)
  }
  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Field), {
        id: __props.id,
        modelValue: _ctx.radioValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radioValue) = $event)),
        name: __props.name,
        type: "radio",
        value: __props.value,
        class: "hidden",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (setValue(_ctx.radioValue)))
      }, null, 8, ["id", "modelValue", "name", "value"]),
      _createElementVNode("label", {
        class: "flex h-5 w-fit px-2 rounded-3xl justify-center items-center cursor-pointer capitalize",
        for: __props.id,
        name: "label"
      }, [
        _renderSlot(_ctx.$slots, "icon"),
        _createTextVNode(_toDisplayString(__props.label), 1)
      ], 8, _hoisted_3)
    ]),
    _createVNode(_unref(ErrorMessage), {
      class: "block text-sm text-red-400",
      name: __props.name
    }, null, 8, ["name"])
  ]))
}
}

})